export abstract class JsonView {}
